export enum DynamicListOrderType {
  Numeric = 1,
}

export const DynamicListOrderTypeToString = {
  [DynamicListOrderType.Numeric]: "Numeric",
}